export default __webpack_public_path__ + "483830115a3d972bf594b4c6c5ec75e0.png";